export function downloadJsonToCsv(data, fields, filename = 'data', headers = null, inlcudeIndexCol = true) {
    let csvData = convertToCSV(data, fields, headers = headers, inlcudeIndexCol = inlcudeIndexCol);

    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
        dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}

export function convertToCSV(objArray, fieldsList, headerList = null, inlcudeIndexCol = true) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = inlcudeIndexCol ? 'S.No,' : '';
    if (headerList) {
        for (let index in headerList) {
            row += headerList[index] + ',';
        }
    } else {
        for (let index in fieldsList) {
            row += fieldsList[index] + ',';
        }
    }

    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
        let line = inlcudeIndexCol ? (i + 1) + ',' : '';
        for (let index in fieldsList) {
            let field = fieldsList[index];
            line += array[i][field] + ',';
        }
        line = line.slice(0, -1);
        str += line + '\r\n';
    }
    return str;
}
